<template>
    <!-- v-if="pageId==='3'" -->
	<div     >
        <!-- check sheet  -->

        <el-dialog
        :title="current_form.case_name"
        :visible.sync="detail_visible"
        width="75%"
        top='5vh'
        custom-class="detail_dia"
        :before-close="CloseDetal"
        >
        
        <template_1002    v-if="current_template_id=='1002'"  mode="check"  :form="current_form"     ></template_1002>
        <template_1001 v-if="current_template_id=='1001'"  :form="current_form"   mode="check"    ></template_1001>

    
        <template_1003   v-if="current_template_id=='1003'"  mode="check"  :form="current_form"     ></template_1003>
        <template_1004   v-if="current_template_id=='1004'"   mode="check"   :form="current_form"     ></template_1004>
        <template_1005   v-if="current_template_id=='1005'"  mode="check"  :form="current_form"     ></template_1005>

        <template_shoufei   v-if="current_template_id=='shoufei'"   mode="check"   :form="current_form"     ></template_shoufei>
        <template_invoice   v-if="current_template_id=='invoice'"  mode="check"  :form="current_form"     ></template_invoice>
        <template_refund   v-if="current_template_id=='refund'"  mode="check"   :form="current_form"     ></template_refund>

        <template_mail   v-if="current_template_id=='mail'"  mode="check"  :form="current_form"     ></template_mail>
        <template_takeoff   v-if="current_template_id=='takeoff'"  mode="check"   :form="current_form"     ></template_takeoff>
            
        <close_case   v-if="current_template_id=='close_case'"  mode="check"   :form="current_form"     ></close_case>
        <self_notice   v-if="current_template_id=='self_notice'"  mode="check"   :form="current_form"  ></self_notice>
 
        
 
        <span slot="footer" class="dialog-footer">
            <!-- <el-button  @click="CloseDetal">取 消</el-button> -->
            <el-button type="primary"   @click="CloseDetal">关 闭</el-button>

             <!-- @click="detail_visible = false"
              @click="detail_visible = false" -->
        </span>
        </el-dialog>

    </div>
	
</template>

<script>
     

    import template_1001 from '@/components/oa/template_id/1001.vue'
    import template_1002 from '@/components/oa/template_id/1002.vue'
    import template_1003 from '@/components/oa/template_id/1003.vue'
    import template_1004 from '@/components/oa/template_id/1004.vue'
    import template_1005 from '@/components/oa/template_id/1005.vue'
    import template_shoufei from '@/components/oa/template_id/shoufei.vue' 

    import template_invoice from '@/components/oa/template_id/invoice.vue'
    import template_refund from '@/components/oa/template_id/refund.vue'

    import template_mail from '@/components/oa/template_id/mail.vue'
    import template_takeoff from '@/components/oa/template_id/takeoff.vue'

    import close_case from '@/components/oa/template_id/close_case.vue'
    import self_notice from '@/components/oa/template_id/self_notice.vue'



	export default {
    name: 'check_sheet',
    props: {
            detail_visible:Boolean,
            current_form:Object,
            current_template_id:String,
        },
        components: { 
 
            template_1001,      
            template_1002,
            template_1003,
            template_1004,
            template_1005,
            template_shoufei,
            template_invoice,
            template_refund,
            template_mail,
            template_takeoff,
            close_case,
            self_notice,
   
            
         
        },
        data() {
			return { 
            //    detail_visible:true ,
                // detail_visible:false,
                screenHeight:window.innerHeight || '',
           
			}
        },
        mounted(){
            // let t=setTimeout( ()=>{
            //     console.log(window.innerHeight)
            //     if(window.innerHeight){
            //         this.screenHeight=window.innerHeight
            //         clearInterval(t)
            //     }


            // },500)
             
        //    this.GetSheet(this.current_form._id)
           
        },
        updated(){
            // this.GetSheet(this.current_form._id)


        },
        
        methods: {
            CloseDetal(){
                console.log('check sheet CloseDetal')
                this.$emit('CloseDetalHandle', false ) 
            },



            GetSheet(_id){
                var that=this
                var data= { 
                    whattodo: "get_sheet",
                    _id:_id,
                    mode:this.mode
                }
        
                this.axios.post(this.$root.rootUrl+'oa',data
                ).then(function (res) {
                    // window.console.log(res)
                    if(res.status==200){
                        let result=res.data
                        // console.log('result:',result)
                        if(result.status=='ok'){

                            let form= result.data.form
                            form.isclose=result.data.isclose 
                            form.applier=result.data.applier 

                            that.current_form=form
                   
                            // that.sheet=result.data
                            // that.current_form.isclose=that.sheet.isclose 
                            // that.current_form.applier=that.sheet.applier 


                            // if(result.data['staff']){
                            //     let staff=result.data['staff']
                            //     staff.sort(function(a, b){
                            //         return a.step - b.step;
                            //     });

                            //     let dic={};let arr=[];
                            //     for (let p of staff){
                            //         if( dic[p.step] ){
                            //             dic[p.step].push(p)
                            //         }else{
                            //             dic[p.step]=[p]
                            //         }
                            //     }
                       
                            //     for (let key in dic){
                            //         arr.push(dic[key])
                            //     }

                          
                            //     that.examine_staff=arr


 
                            // }



                        }else if(result.status=='fail'){

                            that.$message({
                                message: result.failMsg || result.msg,
                                type: 'info',
                                showClose:true,
                                duration:3000,
                            });

                        }

            
        
                    }
                
                    // that.get_sheet_sig=1
                    
                }).catch(function (error) {
                    window.console.log(error);
                    // that.get_sheet_sig=1
                
                });
            },
        


        }
	}
</script>

<style >
 .detail_dia{
    overflow-y: scroll;
    max-height: 90vh;
    border-radius: 5px;
 }

</style>
